import React, { ReactNode } from "react";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";

type Props = {
  number: string;
  subTitle?: string;
  title: ReactNode;
  description: string;
  imageData?: IGatsbyImageData;
  direction?: "ltr" | "rtl";
};

export const Feature: React.FC<Props> = ({ number, direction = "rtl", title, subTitle, description, imageData }) => {
  return (
    <>
      <div className={direction === "rtl" ? "wrapper wrapperRtl" : "wrapper"}>
        {imageData && (
          <div className="imageWrapper">
            <GatsbyImage image={imageData} alt="" />
          </div>
        )}
        <div className="textWrapper">
          <div className="numberAndTitleWrapper">
            <p className="number">{number}</p>
            <div className="titleWrapper">
              {subTitle && <p className="subTitle">{subTitle}</p>}
              <h3 className="title">{title}</h3>
            </div>
          </div>
          <p className="description">{description}</p>
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          align-items: center;
          gap: 48px;
          margin: 0;
          padding: 40px 0;
        }
        .wrapperRtl {
          flex-direction: row-reverse;
        }

        .imageWrapper {
          flex: none;
          width: 44%;
        }

        .textWrapper {
          flex: 1;
          min-width: 0;
        }

        .numberAndTitleWrapper {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          padding-bottom: 18px;
          border-bottom: 1px solid ${colors.subOrange};
        }
        .number {
          margin: 0;
          color: ${colors.brand};
          font-size: 42px;
          font-weight: bold;
          line-height: 1;
          letter-spacing: 0.02em;
        }
        .titleWrapper {
          display: flex;
          flex-direction: column;
          gap: 4px;
          padding-top: 4px;
        }
        .subTitle {
          margin: 0;
          color: ${colors.defaultText};
          font-size: 17px;
          font-weight: bold;
          line-height: 1.5;
        }
        .title {
          margin: 0;
          color: ${colors.defaultText};
          font-size: 32px;
          font-weight: bold;
          line-height: 1.35;
          letter-spacing: 0.02em;
        }
        .description {
          margin: 18px 0 0;
          color: ${colors.defaultText};
          font-size: 17px;
          line-height: 1.9;
        }

        @media (${breakPoints.tablet}) {
          .wrapper {
            gap: 32px;
            padding: 32px 0;
          }
          .title {
            font-size: 28px;
          }
        }

        @media (${breakPoints.sp}) {
          .wrapper,
          .wrapperRtl {
            flex-direction: column;
            align-items: stretch;
            gap: 20px;
            padding: 28px 0;
          }
          .imageWrapper {
            width: 100%;
            max-width: 360px;
            margin: 0 auto;
          }
          .textWrapper {
            order: -1;
          }
          .numberAndTitleWrapper {
            gap: 12px;
            padding-bottom: 14px;
          }
          .number {
            font-size: 32px;
          }
          .subTitle {
            display: none;
          }
          .title {
            font-size: 24px;
          }
          .description {
            margin-top: 12px;
            font-size: 15px;
            line-height: 1.8;
          }
        }
      `}</style>
    </>
  );
};
